<script>
  import { fly } from 'svelte/transition';
  import { onMount } from 'svelte';
  import Motion, { useMotion } from '../Motion';
  import { MEDIUM } from '../Motion/duration';
  import { entrance, exit } from '../Motion/easing';

  const motion = useMotion();

  export let tray;
  $: ({ position } = tray);

  const MAGNITUDE = 200;

  let container;

  const sign = (pos) => {
    switch (pos) {
      case 'bottom': { return { x: 0, y: 1 }; }
      case 'top': { return { x: 0, y: -1 }; }
      case 'right': { return { x: 1, y: 0 }; }
      case 'left': { return { x: -1, y: 0 }; }
      default: { return { x: 0, y: 0 }; }
    }
  };

  $: duration = motion === Motion.NONE ? 0 : MEDIUM;
  $: ({ x, y } = sign($position));

  onMount(() => {
    container.append(tray.element);
    return () => {
      tray.element.remove();
      tray.dispatch('remove');
    };
  });
</script>

<div class='tray-backdrop'>
  <div
    in:fly={{
      x: x * MAGNITUDE,
      y: y * MAGNITUDE,
      easing: entrance,
      duration,
    }}
    out:fly={{
      x: x * MAGNITUDE,
      y: y * MAGNITUDE,
      easing: exit,
      duration,
    }}
    class='tray-container {$position}'
    bind:this={container} />
</div>

<style lang="postcss">
  .tray-backdrop {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .tray-backdrop-background {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: var(--color--backdrop);
    pointer-events: none;
  }

  .tray-container {
    box-sizing: border-box;
    background-color: var(--color--default--background);
    box-shadow: 0 0 8px var(--color--shadow);
    pointer-events: all;
    z-index: var(--Tray--z-index);
    overflow: hidden;

    &.bottom {
      margin: auto auto 0 auto;
      border-radius: var(--radius--l) var(--radius--l) 0 0;
    }

    &.top {
      margin: 0 auto auto auto;
      border-radius: 0 0 var(--radius--l) var(--radius--l);
    }

    &.left {
      margin: auto auto auto 0;
      border-radius: 0 var(--radius--l) var(--radius--l) 0;
    }

    &.right {
      margin: auto 0 auto auto;
      border-radius: var(--radius--l) 0 0 var(--radius--l);
    }
  }
</style>
